// Lista de países con códigos ISO 3166-1 alpha-3 (requerido por Mossos)
// Ordenados por frecuencia de uso en Hotel Guilleumes

export interface Country {
  code: string // ISO 3166-1 alpha-3
  name: {
    es: string
    ca: string
    en: string
    fr: string
  }
}

export const countries: Country[] = [
  // Más frecuentes primero
  { code: 'ESP', name: { es: 'España', ca: 'Espanya', en: 'Spain', fr: 'Espagne' } },
  { code: 'FRA', name: { es: 'Francia', ca: 'França', en: 'France', fr: 'France' } },
  { code: 'DEU', name: { es: 'Alemania', ca: 'Alemanya', en: 'Germany', fr: 'Allemagne' } },
  { code: 'GBR', name: { es: 'Reino Unido', ca: 'Regne Unit', en: 'United Kingdom', fr: 'Royaume-Uni' } },
  { code: 'ITA', name: { es: 'Italia', ca: 'Itàlia', en: 'Italy', fr: 'Italie' } },
  { code: 'PRT', name: { es: 'Portugal', ca: 'Portugal', en: 'Portugal', fr: 'Portugal' } },
  { code: 'NLD', name: { es: 'Países Bajos', ca: 'Països Baixos', en: 'Netherlands', fr: 'Pays-Bas' } },
  { code: 'BEL', name: { es: 'Bélgica', ca: 'Bèlgica', en: 'Belgium', fr: 'Belgique' } },
  { code: 'CHE', name: { es: 'Suiza', ca: 'Suïssa', en: 'Switzerland', fr: 'Suisse' } },
  { code: 'USA', name: { es: 'Estados Unidos', ca: 'Estats Units', en: 'United States', fr: 'États-Unis' } },
  { code: 'AND', name: { es: 'Andorra', ca: 'Andorra', en: 'Andorra', fr: 'Andorre' } },
  
  // Resto de Europa
  { code: 'AUT', name: { es: 'Austria', ca: 'Àustria', en: 'Austria', fr: 'Autriche' } },
  { code: 'POL', name: { es: 'Polonia', ca: 'Polònia', en: 'Poland', fr: 'Pologne' } },
  { code: 'CZE', name: { es: 'República Checa', ca: 'República Txeca', en: 'Czech Republic', fr: 'République tchèque' } },
  { code: 'DNK', name: { es: 'Dinamarca', ca: 'Dinamarca', en: 'Denmark', fr: 'Danemark' } },
  { code: 'SWE', name: { es: 'Suecia', ca: 'Suècia', en: 'Sweden', fr: 'Suède' } },
  { code: 'NOR', name: { es: 'Noruega', ca: 'Noruega', en: 'Norway', fr: 'Norvège' } },
  { code: 'FIN', name: { es: 'Finlandia', ca: 'Finlàndia', en: 'Finland', fr: 'Finlande' } },
  { code: 'IRL', name: { es: 'Irlanda', ca: 'Irlanda', en: 'Ireland', fr: 'Irlande' } },
  { code: 'GRC', name: { es: 'Grecia', ca: 'Grècia', en: 'Greece', fr: 'Grèce' } },
  { code: 'HUN', name: { es: 'Hungría', ca: 'Hongria', en: 'Hungary', fr: 'Hongrie' } },
  { code: 'ROU', name: { es: 'Rumanía', ca: 'Romania', en: 'Romania', fr: 'Roumanie' } },
  { code: 'BGR', name: { es: 'Bulgaria', ca: 'Bulgària', en: 'Bulgaria', fr: 'Bulgarie' } },
  { code: 'HRV', name: { es: 'Croacia', ca: 'Croàcia', en: 'Croatia', fr: 'Croatie' } },
  { code: 'SVK', name: { es: 'Eslovaquia', ca: 'Eslovàquia', en: 'Slovakia', fr: 'Slovaquie' } },
  { code: 'SVN', name: { es: 'Eslovenia', ca: 'Eslovènia', en: 'Slovenia', fr: 'Slovénie' } },
  { code: 'EST', name: { es: 'Estonia', ca: 'Estònia', en: 'Estonia', fr: 'Estonie' } },
  { code: 'LVA', name: { es: 'Letonia', ca: 'Letònia', en: 'Latvia', fr: 'Lettonie' } },
  { code: 'LTU', name: { es: 'Lituania', ca: 'Lituània', en: 'Lithuania', fr: 'Lituanie' } },
  { code: 'LUX', name: { es: 'Luxemburgo', ca: 'Luxemburg', en: 'Luxembourg', fr: 'Luxembourg' } },
  { code: 'MLT', name: { es: 'Malta', ca: 'Malta', en: 'Malta', fr: 'Malte' } },
  { code: 'CYP', name: { es: 'Chipre', ca: 'Xipre', en: 'Cyprus', fr: 'Chypre' } },
  { code: 'ISL', name: { es: 'Islandia', ca: 'Islàndia', en: 'Iceland', fr: 'Islande' } },
  { code: 'UKR', name: { es: 'Ucrania', ca: 'Ucraïna', en: 'Ukraine', fr: 'Ukraine' } },
  { code: 'RUS', name: { es: 'Rusia', ca: 'Rússia', en: 'Russia', fr: 'Russie' } },
  { code: 'SRB', name: { es: 'Serbia', ca: 'Sèrbia', en: 'Serbia', fr: 'Serbie' } },
  { code: 'MNE', name: { es: 'Montenegro', ca: 'Montenegro', en: 'Montenegro', fr: 'Monténégro' } },
  { code: 'ALB', name: { es: 'Albania', ca: 'Albània', en: 'Albania', fr: 'Albanie' } },
  { code: 'MKD', name: { es: 'Macedonia del Norte', ca: 'Macedònia del Nord', en: 'North Macedonia', fr: 'Macédoine du Nord' } },
  { code: 'BIH', name: { es: 'Bosnia y Herzegovina', ca: 'Bòsnia i Hercegovina', en: 'Bosnia and Herzegovina', fr: 'Bosnie-Herzégovine' } },
  { code: 'MDA', name: { es: 'Moldavia', ca: 'Moldàvia', en: 'Moldova', fr: 'Moldavie' } },
  { code: 'BLR', name: { es: 'Bielorrusia', ca: 'Bielorússia', en: 'Belarus', fr: 'Biélorussie' } },
  
  // América
  { code: 'CAN', name: { es: 'Canadá', ca: 'Canadà', en: 'Canada', fr: 'Canada' } },
  { code: 'MEX', name: { es: 'México', ca: 'Mèxic', en: 'Mexico', fr: 'Mexique' } },
  { code: 'BRA', name: { es: 'Brasil', ca: 'Brasil', en: 'Brazil', fr: 'Brésil' } },
  { code: 'ARG', name: { es: 'Argentina', ca: 'Argentina', en: 'Argentina', fr: 'Argentine' } },
  { code: 'CHL', name: { es: 'Chile', ca: 'Xile', en: 'Chile', fr: 'Chili' } },
  { code: 'COL', name: { es: 'Colombia', ca: 'Colòmbia', en: 'Colombia', fr: 'Colombie' } },
  { code: 'PER', name: { es: 'Perú', ca: 'Perú', en: 'Peru', fr: 'Pérou' } },
  { code: 'VEN', name: { es: 'Venezuela', ca: 'Veneçuela', en: 'Venezuela', fr: 'Venezuela' } },
  { code: 'ECU', name: { es: 'Ecuador', ca: 'Equador', en: 'Ecuador', fr: 'Équateur' } },
  { code: 'URY', name: { es: 'Uruguay', ca: 'Uruguai', en: 'Uruguay', fr: 'Uruguay' } },
  { code: 'CUB', name: { es: 'Cuba', ca: 'Cuba', en: 'Cuba', fr: 'Cuba' } },
  { code: 'DOM', name: { es: 'República Dominicana', ca: 'República Dominicana', en: 'Dominican Republic', fr: 'République dominicaine' } },
  
  // Asia
  { code: 'CHN', name: { es: 'China', ca: 'Xina', en: 'China', fr: 'Chine' } },
  { code: 'JPN', name: { es: 'Japón', ca: 'Japó', en: 'Japan', fr: 'Japon' } },
  { code: 'KOR', name: { es: 'Corea del Sur', ca: 'Corea del Sud', en: 'South Korea', fr: 'Corée du Sud' } },
  { code: 'IND', name: { es: 'India', ca: 'Índia', en: 'India', fr: 'Inde' } },
  { code: 'THA', name: { es: 'Tailandia', ca: 'Tailàndia', en: 'Thailand', fr: 'Thaïlande' } },
  { code: 'VNM', name: { es: 'Vietnam', ca: 'Vietnam', en: 'Vietnam', fr: 'Vietnam' } },
  { code: 'PHL', name: { es: 'Filipinas', ca: 'Filipines', en: 'Philippines', fr: 'Philippines' } },
  { code: 'IDN', name: { es: 'Indonesia', ca: 'Indonèsia', en: 'Indonesia', fr: 'Indonésie' } },
  { code: 'MYS', name: { es: 'Malasia', ca: 'Malàisia', en: 'Malaysia', fr: 'Malaisie' } },
  { code: 'SGP', name: { es: 'Singapur', ca: 'Singapur', en: 'Singapore', fr: 'Singapour' } },
  { code: 'ISR', name: { es: 'Israel', ca: 'Israel', en: 'Israel', fr: 'Israël' } },
  { code: 'TUR', name: { es: 'Turquía', ca: 'Turquia', en: 'Turkey', fr: 'Turquie' } },
  { code: 'SAU', name: { es: 'Arabia Saudita', ca: 'Aràbia Saudita', en: 'Saudi Arabia', fr: 'Arabie saoudite' } },
  { code: 'ARE', name: { es: 'Emiratos Árabes Unidos', ca: 'Emirats Àrabs Units', en: 'United Arab Emirates', fr: 'Émirats arabes unis' } },
  { code: 'QAT', name: { es: 'Catar', ca: 'Qatar', en: 'Qatar', fr: 'Qatar' } },
  
  // África
  { code: 'MAR', name: { es: 'Marruecos', ca: 'Marroc', en: 'Morocco', fr: 'Maroc' } },
  { code: 'EGY', name: { es: 'Egipto', ca: 'Egipte', en: 'Egypt', fr: 'Égypte' } },
  { code: 'ZAF', name: { es: 'Sudáfrica', ca: 'Sud-àfrica', en: 'South Africa', fr: 'Afrique du Sud' } },
  { code: 'TUN', name: { es: 'Túnez', ca: 'Tunísia', en: 'Tunisia', fr: 'Tunisie' } },
  { code: 'DZA', name: { es: 'Argelia', ca: 'Algèria', en: 'Algeria', fr: 'Algérie' } },
  { code: 'NGA', name: { es: 'Nigeria', ca: 'Nigèria', en: 'Nigeria', fr: 'Nigeria' } },
  { code: 'SEN', name: { es: 'Senegal', ca: 'Senegal', en: 'Senegal', fr: 'Sénégal' } },
  
  // Oceanía
  { code: 'AUS', name: { es: 'Australia', ca: 'Austràlia', en: 'Australia', fr: 'Australie' } },
  { code: 'NZL', name: { es: 'Nueva Zelanda', ca: 'Nova Zelanda', en: 'New Zealand', fr: 'Nouvelle-Zélande' } },
]

// Función para obtener el nombre del país en el idioma actual
export function getCountryName(code: string, lang: string): string {
  const country = countries.find(c => c.code === code)
  if (!country) return code
  return country.name[lang as keyof typeof country.name] || country.name.en
}

// Función para buscar países por nombre o código
export function searchCountries(query: string, lang: string): Country[] {
  const q = query.toLowerCase()
  return countries.filter(c => 
    c.code.toLowerCase().includes(q) ||
    c.name[lang as keyof typeof c.name]?.toLowerCase().includes(q) ||
    c.name.en.toLowerCase().includes(q)
  )
}

// Mapeig ISO 3166-1 alpha-2 (Google Maps) → alpha-3 (Mossos)
const iso2ToIso3: Record<string, string> = {
  ES: 'ESP', FR: 'FRA', DE: 'DEU', GB: 'GBR', IT: 'ITA', PT: 'PRT',
  NL: 'NLD', BE: 'BEL', CH: 'CHE', US: 'USA', AD: 'AND', AT: 'AUT',
  PL: 'POL', CZ: 'CZE', DK: 'DNK', SE: 'SWE', NO: 'NOR', FI: 'FIN',
  IE: 'IRL', GR: 'GRC', HU: 'HUN', RO: 'ROU', BG: 'BGR', HR: 'HRV',
  SK: 'SVK', SI: 'SVN', EE: 'EST', LV: 'LVA', LT: 'LTU', LU: 'LUX',
  MT: 'MLT', CY: 'CYP', IS: 'ISL', UA: 'UKR', RU: 'RUS', RS: 'SRB',
  ME: 'MNE', AL: 'ALB', MK: 'MKD', BA: 'BIH', MD: 'MDA', BY: 'BLR',
  CA: 'CAN', MX: 'MEX', BR: 'BRA', AR: 'ARG', CL: 'CHL', CO: 'COL',
  PE: 'PER', VE: 'VEN', EC: 'ECU', UY: 'URY', CU: 'CUB', DO: 'DOM',
  CN: 'CHN', JP: 'JPN', KR: 'KOR', IN: 'IND', TH: 'THA', VN: 'VNM',
  PH: 'PHL', ID: 'IDN', MY: 'MYS', SG: 'SGP', IL: 'ISR', TR: 'TUR',
  SA: 'SAU', AE: 'ARE', QA: 'QAT', MA: 'MAR', EG: 'EGY', ZA: 'ZAF',
  TN: 'TUN', DZ: 'DZA', NG: 'NGA', SN: 'SEN', AU: 'AUS', NZ: 'NZL',
}

// Convertir codi ISO alpha-2 (Google Maps) a alpha-3 (Mossos)
export function countryCodeToNationality(iso2Code: string): string | null {
  return iso2ToIso3[iso2Code?.toUpperCase()] || null
}
